import React, { Component } from 'react'
import { Button } from 'antd'
import CustomTable from '../../../elements/Table/CustomTable'
import Authentication from '../../../modules/Authentication'
import ViewDownload from '../../../elements/ViewDownload'
import { streamUrl } from '../../../variables/index'

class List extends Component {
  auth = new Authentication()
  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      width: 150,
      Cell: ({ original, value }) => {
        return <a onClick={() => this.props.onEdit(original, 'edit')}>{value}</a>
      },
    },
    {
      Header: 'Name',
      accessor: 'name',
      width: 150,
    },
    {
      Header: 'Description',
      accessor: 'desc',
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
    },
    {
      Header: 'File',
      accessor: 'file',
      width: 75,
      Cell: ({ value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}?action=view&access_token=${this.auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}?action=download&access_token=${this.auth.getAccessToken()}`}
          />
        ),
    },
  ]

  render() {
    const { onEdit, data, fetching, fetch } = this.props
    return (
      <CustomTable
        CreateButton={() => (
          <Button type={'primary'} size={'small'} icon={'plus'} onClick={onEdit}>
            Create Standard
          </Button>
        )}
        isFilterable={true}
        columns={this.columns}
        data={data}
        fetching={fetching}
        fetch={fetch}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
